import mapping from 'arbitrip-common/theme/mapping';
import { COMPANY_NAME } from 'arbitrip-common/theme/constants';

const ELAL_FAVICON_URL = 'https://elal-assets.s3.eu-central-1.amazonaws.com/elal-fav.ico';

/**
 * Updates the favicon and apple-touch-icon based on whether the company uses ELAL theme
 * @param {string} companyId - The company ID to check
 * @param {boolean} isMobile - Whether this is being called from mobile app (for apple-touch-icon)
 */
const updateFavicon = (companyId, isMobile = false) => {
    if (typeof window === 'undefined') {
        return; // Server-side rendering guard
    }

    const isElal = mapping[companyId] === COMPANY_NAME.ELAL;

    if (isElal) {
        // Remove existing favicon links
        const existingFavicons = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]');
        existingFavicons.forEach((link) => link.remove());

        // Add ELAL favicon
        const faviconLink = document.createElement('link');
        faviconLink.rel = 'icon';
        faviconLink.href = ELAL_FAVICON_URL;
        document.head.appendChild(faviconLink);

        // For mobile, also update apple-touch-icon
        if (isMobile) {
            // Remove existing apple-touch-icon
            const existingAppleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]');
            if (existingAppleTouchIcon) {
                existingAppleTouchIcon.remove();
            }

            // Add ELAL apple-touch-icon (using the same SVG, browsers will handle it)
            const appleTouchIconLink = document.createElement('link');
            appleTouchIconLink.rel = 'apple-touch-icon';
            appleTouchIconLink.href = ELAL_FAVICON_URL;
            document.head.appendChild(appleTouchIconLink);
        }
    }
    // If not ELAL, keep the default favicons from index.html
};

export default updateFavicon;
